'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "create-note-dialog" */'./CreateNoteDialogContainer').then(module => module.CreateNoteDialogContainer);
export default Loadable({
  loader,
  LoadingComponent: () => null
});